import { formActionTypes } from '../../settings/types'

export const clearState = () => ({
    type : formActionTypes.clearState,
});

export const resetCombos = data => ({
    type : formActionTypes.resetCombos,
    payload : data
});

export const setItem = data => ({
    type : formActionTypes.domainObject,
    payload : data
});

export const setLangs = data => ({
    type : formActionTypes.langs,
    payload : data
});

export const setSecondaryLangs = data => ({
    type : formActionTypes.secondaryLangs,
    payload : data
});

export const setForm = ( editMode = false, disableInputs = false, saveSuccess = false) => ({
    type : formActionTypes.formData,
    payload: { editMode, disableInputs, saveSuccess }
});